import { Fragment, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import OrderServices from "../based/services/OrderServices";
import { INITPAGING } from "../based/Constants";
import TableFooter from "../based/content/TableFooter";
import DirectReturnModal from "./DirectReturnModal";
import Common from "../based/Common";
import { useHistory } from "react-router-dom";

//tất cả, đang hoàn về, đợi kiểm, đã kiểm, hoàn tiền
const TabOption = {
    ALL: 1,
    RETURNING: 2,
    CHECKING: 3,
    CHECKED: 4,
    REFUNDED: 5,
};

const TAB_SCREEN = [
    { label: "Tất cả", value: TabOption.ALL },
    { label: "Đang hoàn về", value: TabOption.RETURNING },
    { label: "Đợi kiểm", value: TabOption.CHECKING },
    { label: "Đã kiểm", value: TabOption.CHECKED },
    { label: "Hoàn tiền", value: TabOption.REFUNDED },
];

const orderReturnManageModel = {
    id: 0,
    orderId: 0,
    orderNumber: "",
    userName: "",
    phoneNumber: "",
    provinceCode: "",
    provinceName: "",
    districtCode: "",
    districtName: "",
    wardCode: "",
    wardName: "",
    street: "",
    orderReturnProductManageModels: [], // array of OrderReturnProductManageModel
};

const orderReturnProductManageModel = {
    id: 0,
    orderReturnId: 0,
    orderProductId: 0,
    orderProductType: null, // Replace with actual enum value if needed
    isReFund: false,
    isReProduce: false,
    isReturnDefective: false,
    refundAmount: 0,
    frontImage: "",
    backImage: "",
    size: "",
    color: "",
    appProductName: "",
};

function ReturnOrderOverview(props) {
    const [tabIndex, setTabIndex] = useState(TabOption.ALL);
    const [listOrderReturn, setListOrderReturn] = useState([]); // This should be fetched from an API
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [showCreateReturnModal, setShowCreateReturnModal] = useState(false);
    const history = useHistory();

    useEffect(() => {
        // Fetch initial data when component mounts
        getData(paging);
    }, []);

    const getData = async (page) => {
        const [err, data] = await OrderServices.GetOrderReturnManageModels(page);
        if (!err && data) {
            setListOrderReturn(data.listObjects);
            setPaging(data.paging);
        } else {
            setPaging(page);
        }
    };

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a className={tabIndex == item.value ? "nav-link active" : "nav-link btn-light"} onClick={() => setTabIndex(item.value)}>
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    return (
        <Fragment>
            <Wrapper>
                <Breadcrumbs currentPage="Tổng quan hoàn hàng" />
                {/* {_renderTab} */}
                <section className="render-filter">
                    <div className="list-button">
                        <button
                            className="btn btn-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                setShowCreateReturnModal(true);
                            }}
                        >
                            Tạo đơn hoàn <i className="fa fa-plus"></i>
                        </button>
                    </div>
                </section>
                <section className="table-return-order">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Đơn hàng</th>
                                <th>Hình ảnh</th>
                                <th>Sản phẩm</th>
                                <th>SL trả</th>
                                <th>Tình trạng sản phẩm hoàn về</th>
                                <th>Sản xuất lại</th>
                                <th>Hoàn tiền</th>
                                <th>Trạng thái</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* render table, with colSpan each order return product  */}
                            {listOrderReturn && listOrderReturn.length > 0 ? (
                                listOrderReturn.map((item, index) => {
                                    let totalRefundAmount = item.orderReturnProductManageModels.reduce((sum, p) => sum + p.refundAmount, 0);

                                    return (
                                        item.orderReturnProductManageModels.length > 0 &&
                                        item.orderReturnProductManageModels.map((product, idx) => {
                                            let rowSpan = item.orderReturnProductManageModels.length > 1 ? item.orderReturnProductManageModels.length : 1;
                                            return (
                                                <tr key={`${index}-${idx}`}>
                                                    {idx === 0 && (
                                                        <td rowSpan={rowSpan}>
                                                            <div className="order-info">
                                                                <div className="order-info-item">
                                                                    <span className="order-info-label">Đơn hàng gốc</span>
                                                                    <span className="order-info-value">{item.orderNumber}</span>
                                                                </div>
                                                                <div className="order-info-item">
                                                                    <span className="order-info-label">Tên khách</span>
                                                                    <span className="order-info-value">{item.userName}</span>
                                                                </div>
                                                                <div className="order-info-item">
                                                                    <span className="order-info-label">SĐT</span>
                                                                    <span className="order-info-value">{item.phoneNumber}</span>
                                                                </div>
                                                                <div className="order-info-item">
                                                                    <span className="order-info-label">Địa chỉ</span>
                                                                    <span className="order-info-value">{`${item.street}, ${item.wardName}, ${item.districtName}, ${item.provinceName}`}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    )}
                                                    <td>
                                                        <div className="lst-image">
                                                            {product.frontImage && <img src={product.frontImage} alt="Front" />}
                                                            {product.backImage && <img src={product.backImage} alt="Back" />}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="product-info">
                                                            <div className="product-name">{product.appProductName}</div>
                                                            <div className="product-variant">{`Size: ${product.size}, Màu: ${product.color}`}</div>
                                                        </div>
                                                    </td>
                                                    {idx === 0 && (
                                                        <>
                                                            <td rowSpan={rowSpan}>
                                                                <span className="number">{item.orderReturnProductManageModels.reduce((sum, p) => sum + p.quantityReturned, 0)}</span>
                                                            </td>
                                                            <td rowSpan={rowSpan}></td>
                                                            <td rowSpan={rowSpan}></td>
                                                            <td rowSpan={rowSpan}>
                                                                <span>{Common.formatCurrency(totalRefundAmount)}</span>
                                                            </td>
                                                            <td rowSpan={rowSpan}>
                                                                <div className="status-order">
                                                                    <button className="btn btn-primary" onClick={() => history.push(`/return-order-edit/${item.orderId}`)}>
                                                                        Xem chi tiết
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">
                                        Không có dữ liệu
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <TableFooter
                        paging={paging}
                        onFilter={(page) => {
                            getData(page);
                        }}
                        itemToDisplay={5} // Adjust this value as needed
                    />
                </section>
            </Wrapper>
            <DirectReturnModal show={showCreateReturnModal} onClose={() => setShowCreateReturnModal(false)} />
        </Fragment>
    );
}

export default ReturnOrderOverview;

const Wrapper = styled.div`
    section.table-return-order {
        margin: 24px 0;
    }

    .table thead {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    .table thead tr th {
        vertical-align: middle;
    }

    .order-info {
        width: 300px;
    }

    span.order-info-label {
        width: 30%;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .order-info-item {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    span.order-info-value {
        margin-left: 24px;
        flex: 1;
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .lst-image {
        display: flex;
        justify-content: space-around;
    }

    .lst-image img {
        width: 70px;
        height: 70px;
        object-fit: contain;
    }

    tbody tr td {
        background: white;
    }

    .product-info .product-name {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 142.857% */
    }

    .product-info .product-variant {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
    }

    span.number {
        color: #444;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .status-note input {
        color: #a0a0a0;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border: none;
    }

    .status-refund {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    span.refund-value {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        margin: 5px 0;
    }

    .status-refund .btn {
        border-radius: 50px;
        background: #f96a74;
        padding: 5px 10px;
        color: #fff !important;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 5px 0px;
    }

    .status-order {
        display: flex;
        flex-direction: column;
    }

    .status-order span {
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 5px 0;
    }

    .status-order .btn {
        background: #343c49 !important;
        border: none !important;
        font-size: 16px;
        margin: 5px 0;
    }
`;
